export function lockoutModalShown (data) {
  window.analytics.track('Lockout Modal Shown', {
    lockout_type: data.lockoutType,
    workspace_id: data.workspaceId,
    workspace_slug: data.workspaceSlug,
    current_plan: data.currentPlan
  })
}

export function lockoutModalClicked (data) {
  window.analytics.track('Lockout Modal Clicked', {
    lockout_type: data.lockoutType,
    workspace_id: data.workspaceId,
    workspace_slug: data.workspaceSlug,
    current_plan: data.currentPlan
  })
}

export function lockoutOptionClicked (data) {
  window.analytics.track('Lockout Option Clicked', {
    lockout_type: data.lockoutType,
    lockout_option: data.lockoutOption,
    workspace_id: data.workspaceId,
    workspace_slug: data.workspaceSlug,
    current_plan: data.currentPlan
  })
}



// WEBPACK FOOTER //
// ./analytics/lockouts.js